declare interface Array<T> {
  takeRandom(): T;
}

Array.prototype.takeRandom = function <T>(this: T[]) {
  return this[Math.floor(Math.random() * this.length)];
};
